import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import useStore from '../../../../store';
import { Button, Form, Modal, Spin } from 'antd';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';
import FormComponent from './FormComponent';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [form] = Form.useForm();
	const { PUBLICSETTINGS, ROOT } = useStore();
	const { publicSettingDetail } = PUBLICSETTINGS;

	const handleSubmit = (data) => {
		setSaving(true);
		const payload = {
			...data,
			id: publicSettingDetail.id,
			versionNo: publicSettingDetail.versionNo,
			settingdbType: data.settingdbType !== null && data.settingdbType !== '' ? Number(data.settingdbType) : 0,
		};
		PUBLICSETTINGS.editPublicSettings(payload)
			.then(() => {
				PUBLICSETTINGS.publicSettingDetail = null;
				Notification.success({
					message: Message().CRUD.UPDATE('Public Settings'),
				});
				closeModal();
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	useEffect(() => {
		if (visible && publicSettingDetail) {
			form.setFieldsValue({
				settingKey: publicSettingDetail.settingKey,
				settingName: publicSettingDetail.settingName,
				settingValue: publicSettingDetail.settingValue,
				settingdbType: publicSettingDetail.settingdbType !== null && publicSettingDetail.settingdbType !== '' ? publicSettingDetail.settingdbType.toString(): '0',
			});
		}
	}, [visible, publicSettingDetail]);

	const closeModal = async () => {
		setDisabled(true);
		PUBLICSETTINGS.publicSettingDetail = null;
		form.resetFields();
		onClose();
	};

	return (
		<Modal
			title="Edit Public Settings"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditForm"
					>
						Update Settings
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!PUBLICSETTINGS.publicSettingDetail}>
				<FormComponent
					id="EditForm"
					form={form}
					onFinish={handleSubmit}
					handleChange={handleChange}
				/>
			</Spin>
		</Modal>
	);
});
export default EditComponent;
